import { Component, OnInit, AfterViewInit, Injectable, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Table as DataTable } from 'primeng/table';
import { EventSearchParams } from './event-search-params.model';

import { NotificationService, DialogService, PagedResult, PagedSearch, DatagridService } from '../../shared/index'; // app/shared/index barrel;
import { EventsService } from '../shared/events.service';
import { BusyIndicatorComponent } from '../../shared/widgets/busy-indicator/busy-indicator.component';

@Component({
  selector: 'wl-events-search',
  templateUrl: 'events-search.component.html',
  styleUrls: ['events-search.component.css'],
  providers: [EventsService, DatagridService],
    standalone: false
})
@Injectable()
export class EventsSearchComponent implements AfterViewInit {
  @ViewChild('searchEventsDataGrid', { static: false }) public searchEventsDataGrid: DataTable;

  public _dialogService: DialogService;
  public _router: Router;
  public _eventsService: EventsService;
  public _dataGridService: DatagridService;

  public errorMessage: string;
  public upcomingEvents: PagedResult;
  public searchParams: EventSearchParams;
  public isSearching: boolean;

  public constructor(router: Router, dialogService: DialogService, eventsService: EventsService, dataGridService: DatagridService) {
    this._dialogService = dialogService;
    this._router = router;
    this._eventsService = eventsService;
    this._dataGridService = dataGridService;
    this.upcomingEvents = new PagedResult();
    this.errorMessage = '';
    this.searchParams = new EventSearchParams();
    this.isSearching = false;
  }

  ngAfterViewInit() {
    // datagrid/search param paging config
    // the dataGrid variable will only exist AfterViewInit
    this._dataGridService.applyPagingDefaults(this.searchEventsDataGrid, this.searchParams);

    this._dataGridService.lazyLoadEvent.subscribe((pagingParams: PagedSearch) => {
      // update the search params based on the paging data emitted from the lazy load event
      this.searchParams = this._dataGridService.mapPagedSearchToParams(this.searchParams, pagingParams);

      // now run load the data with the updated paging info
      this.loadEvents().then(() => {
        // post load update the total pages etc info that is returned from the paged data service
        this.searchParams = this._dataGridService.mapPagedResultToParams(this.upcomingEvents, this.searchParams);
      });
    });

    this.loadEvents();
  }

  public loadEvents = (evt: any = null): Promise<any> => {
    this.isSearching = true;
    this._dataGridService.applyPagingDefaults(this.searchEventsDataGrid, this.searchParams);

    return this._eventsService.searchEvents(this.searchParams).then(
      (data: any) => {
        this.isSearching = false;
        this.upcomingEvents = data;
      },
      (error: any) => {
        this.isSearching = false;
        this._dialogService.error(error);
      }
    );
  };
}
